export default {"src":"/_next/static/media/human-emotions.mono.9d7d469c.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};